import React from 'react'

function Rejected(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={30}
      height={30}
      fill="none"
      {...props}
    >
      <path
        fill="#D43F3C"
        d="M13 0a13 13 0 1 0 0 26 13 13 0 0 0 0-26Zm3.523 14.677a1.3 1.3 0 0 1 0 1.846 1.3 1.3 0 0 1-1.846 0L13 14.833l-1.677 1.69a1.3 1.3 0 0 1-1.846 0 1.3 1.3 0 0 1 0-1.846L11.167 13l-1.69-1.677a1.305 1.305 0 0 1 1.846-1.846L13 11.167l1.677-1.69a1.305 1.305 0 1 1 1.846 1.846L14.833 13l1.69 1.677Z"
      />
    </svg>
  )
}
export default Rejected
